<div
  #chart
  resizeObserver
  (resize)="resizeChart($event)"
  [caller]="'#chart'"
  class="chart viz"
  [ngClass]="{ 'hide-chart': noData() || noSeries(), 'loaded-view': loadedView() || noData(), 'hide-scrollbar': hideScrollbar() }"
  (scroll)="handleScroll($event)"
></div>

@if (noData()) {
  <div class="no-data loaded-view">{{ content().typeSpecific.noDataMessages.visual }}</div>
}

@if (noSeries()) {
  <div class="no-data loaded-view">Series must contain more than 1 value</div>
}
<!-- outline outline-1 outline-amber-600 -->
